import { NeoUsuarioIntermediario } from './neoUsuarioIntermediario';
export class NeoUsuarioXRol {
  constructor(
    public usuario: NeoUsuarioIntermediario,
    public roles:Number[]=[]
  ) {}
}